/**
 * Configuración de líneas de referencia.
 *
 * Política (v0.20.75+):
 * - Viewer común (≥2 viewports): CornerstoneTools ReferenceLines (verdes vía toolColors).
 * - MPR: solo cruz amarilla UDV (`mprCrosshair` overlay). CT se apaga en MPR.
 * - Método CUSTOM (canvas): legacy — desactivado en UI y runtime.
 *
 * @see docs/MANUAL-0.20.75-MPR-YELLOW-CORRELATION.md
 */

export const REFERENCE_LINES_METHODS = {
  CUSTOM: 'custom', // legacy — no usar
  CORNERSTONE_TOOLS: 'cornerstone-tools'
}

export const DEFAULT_REFERENCE_LINES_METHOD = REFERENCE_LINES_METHODS.CORNERSTONE_TOOLS

// Configuración específica para CornerstoneTools
export const CORNERSTONE_REFERENCE_LINES_CONFIG = {
  enabled: false,
  synchronizer: null,
  elements: [],
  toolName: 'ReferenceLines'
}

/**
 * Nota de color (no se aplica por código aquí):
 * - CT ReferenceLines usa toolColors.getActiveColor() → #76FF03 (verde lima en DicomViewer).
 * - Cruz MPR UDV usa #FFEB3B en overlay HTML (DicomViewer).
 * El objeto cornerstoneTools.mainLine abajo es legacy / documentación; no pinta el tool.
 */
export const REFERENCE_LINES_STYLES = {
  cornerstoneTools: {
    mainLine: {
      color: 'rgba(255, 255, 0, 0.85)',
      width: 2
    }
  },
  mprYellowCorrelation: {
    color: '#FFEB3B',
    colorSoft: 'rgba(255, 235, 59, 0.85)'
  }
}

// Configuración de validaciones
export const REFERENCE_LINES_VALIDATIONS = {
  minViewports: 2,
  minDistance: 30, // Math.max(rows, cols) / 30
  enableLogging: true
}
